var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"left_pages"},_vm._l((_vm.$store.state.app.pages),function(item,i){return _c('li',{key:i,class:_vm.$store.state.app.now_page == item.name ? 'select_page' : '',on:{"click":function($event){return _vm.jump(item)}}},[_vm._v("\n    "+_vm._s(item.title)+"\n    ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29bcbe21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/left_sidebar/page.vue
// module id = null
// module chunks = 